var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccompanying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colored-stroke",
    d: "M20.6667 22.5V20.1667C20.6667 18.929 20.175 17.742 19.2998 16.8668C18.4247 15.9917 17.2377 15.5 16 15.5H6.66667C5.42899 15.5 4.242 15.9917 3.36684 16.8668C2.49167 17.742 2 18.929 2 20.1667V22.5",
    stroke: "#6024B8",
    strokeWidth: 2.01923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "colored-stroke",
    d: "M11.3346 10.8333C13.912 10.8333 16.0013 8.744 16.0013 6.16667C16.0013 3.58934 13.912 1.5 11.3346 1.5C8.75731 1.5 6.66797 3.58934 6.66797 6.16667C6.66797 8.744 8.75731 10.8333 11.3346 10.8333Z",
    stroke: "#6024B8",
    strokeWidth: 2.01923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "colored-stroke",
    d: "M26.334 22.8483V20.515C26.3332 19.481 25.9891 18.4766 25.3556 17.6594C24.7221 16.8422 23.8351 16.2585 22.834 16",
    stroke: "#6024B8",
    strokeWidth: 2.01923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "colored-stroke",
    d: "M19.5 1.65161C20.5038 1.90863 21.3935 2.49243 22.0289 3.31097C22.6643 4.12952 23.0091 5.13625 23.0091 6.17244C23.0091 7.20864 22.6643 8.21537 22.0289 9.03392C21.3935 9.85246 20.5038 10.4363 19.5 10.6933",
    stroke: "#6024B8",
    strokeWidth: 2.01923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccompanying);
export default __webpack_public_path__ + "static/media/accompanying.5e0a4e3b.svg";
export { ForwardRef as ReactComponent };